import keyMirror from "keymirror";

const GenerateUsernamesActionNames = keyMirror({
    GENERATE_USERNAMES: null,
    GENERATE_USERNAMES_SUCCESS: null,
    GENERATE_USERNAMES_ERROR: null
});

export default GenerateUsernamesActionNames;
